import { render, staticRenderFns } from "./msgGoodsStore.vue?vue&type=template&id=731d8996&scoped=true&"
import script from "./msgGoodsStore.vue?vue&type=script&lang=js&"
export * from "./msgGoodsStore.vue?vue&type=script&lang=js&"
import style0 from "./msgGoodsStore.vue?vue&type=style&index=0&id=731d8996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731d8996",
  null
  
)

export default component.exports